export const LIVE_REPORT_REASONS = Object.freeze([
  Object.freeze({ value: "nudity-or-sexual-content", label: "Nudity or sexual content" }),
  Object.freeze({ value: "violence-or-dangerous-acts", label: "Violence or dangerous acts" }),
  Object.freeze({ value: "hate-speech-or-harassment", label: "Hate speech or harassment" }),
  Object.freeze({ value: "spam-or-scam", label: "Spam or scam" }),
  Object.freeze({ value: "other", label: "Other" }),
]);
